import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {ProjectService} from '../project.service';
import {Client} from 'src/app/model/client';
import {Json2TypescriptUtil} from '../../util/json2TypescriptUtil';
import {GenericModalComponent} from '../../modal/generic-modal.component';
import {Project} from '../../model/project';
import {FormModel} from '../../model/forms/form-model';
import {ClientFormUtil} from '../../model/FormUtil/clientFormUtil';
import {CreateObjectDialogComponent} from '../../createObjectDialog/create-object-dialog.component';

@Component({
    selector: 'clientManager',
    template: `<div class="modal" [style.display]="!hide ? 'inline' : 'none'" >
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <!-- header-->
                <div class="modal-header">
                    <h4 class="modal-title"><span><img alt="icon" class="appWindow" src="../../assets/images/075.png"></span></h4>
                    <h4>Client Manager</h4>
                    <h4 class="closeBtnH4"><button (click)="toggleDialog();" class="btn btn-outline-danger my-2 my-sm-0 closeBtnDiv" data-dismiss="modal" aria-label="Close">
                        <span class="closeX" aria-hidden="true"><img class="closeIcon" alt="closeBtn" src="../../assets/images/closeBtn.png"></span>
                    </button></h4>
                </div>
                <div class="modalBodyContainer">
                    <div class="modal-body">
                        <table class="table">
                            <thead class="tableHeader">
                            <tr>
                                <th>Client Name</th>
                                <th>Registered On</th>
                                <th>Access Status</th>
                                <th>Action</th>
                                <th>Modify</th>
                                <th>Revoke Access</th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr class="clientRow" *ngFor="let item of clients" style="border-bottom: 2px solid #444444;align-content: center;">
                                    <td>
                                        <div *ngIf="editUserId === item.id" role="alert" style="margin-left:35%;font-weight:bold;height: 18px; width:250px;padding-top:1px;font-size: 14px;margin-top:15px;">
                                            <div><span style="margin-right: 10px;color:#0aa361;float: left;"><img alt="user" style="width: 32px;" src="../../../assets/images/user.png"></span></div>
                                            <div style="text-align: center;float: left;"><input type="text" class="form-control" style="float: left;height:28px;width:175px;" [value]="item.name" [(ngModel)]="modifiedUserVal"><span style="margin-left: 2px;"><button  style="width:27px;height:27px;" class="btn btn-success btn-xs modOK" (click)="saveMod(item.id,modifiedUserVal)"></button></span></div>
                                        </div>
                                        <div *ngIf="editUserId !== item.id" role="alert" style="margin-left:35%;font-weight:bold;height: 22px; width:250px;padding-top:1px;font-size: 14px;margin-top:15px;">
                                            <div><span style="margin-right: 10px;color:#0aa361;float: left;"><img alt="user" style="width: 32px;" src="../../../assets/images/user.png"></span></div>
                                            <div style="text-align: center;float: left;"></div><strong>{{item.name}}</strong>
                                        </div>
                                    </td>
                                    <td>
                                        <div role="alert"
                                             style="text-align:center;font-weight:bold;height: 18px;margin-left:22%; width:150px;padding-top:1px;font-size: 14px;margin-top:15px;">
                                            <strong>{{item.registeredDate}}</strong>
                                        </div>
                                    </td>
                                    <td>
                                        <div role="alert"
                                             style="margin-left: 35%;text-align:center;font-weight:bold;height: 18px; width:50px;padding-top:1px;font-size: 14px;margin-top:15px;">
                                            <span style="margin-right: 10px;color:#0aa361;"><img alt="led" class="led" [src]="turnOnLED(item.accessStatus)"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <div role="alert" style="margin-left:10%;text-align:center;font-weight:bold;height: 18px; width:50px;padding-top:1px;font-size: 14px;margin-top:15px;">
                                            <button class="btn btn-danger btn-xs"
                                                    (click)="onRemove(item.id);">
                                                <span class="glyphicon glyphicon-trash"></span> Remove
                                            </button>
                                        </div>
                                    </td>
                                    <td>
                                        <div role="alert" style="margin-left:28%;text-align:center;font-weight:bold;height: 18px; width:fit-content;padding-top:1px;font-size: 14px;margin-top:15px;">
                                            <button  class="btn btn-warning btn-xs"
                                                    (click)="onUpdate(item.id,item.name);">
                                                <span style="color:#ffffff;"><i  style="font-size: large" class="far fa-edit"></i></span>
                                            </button>
                                        </div>
                                    </td>
                                    <td>
                                        <div role="alert" style="margin-left:20%;text-align:center;font-weight:bold;height: 18px; width:150px;padding-top:1px;font-size: 14px;margin-top:15px;">
                                            <button *ngIf="item.accessStatus" class="btn btn-danger btn-xs"
                                                    (click)="onRemove(item.id);">
                                                <span class="glyphicon glyphicon-trash"></span> Access
                                            </button>

                                            <button *ngIf="!item.accessStatus" class="btn btn-success btn-xs"
                                                    (click)="createAccess(item.id);">
                                                Grant Access
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary clickable hand" (click)="showAddClient()" >New Client</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <generic-info-modal (OkClick)="onOk()"></generic-info-modal>
    <create-object-dialog (NewObjectEvent)="onNewEvent($event)" [modelObject]="intentModel" [formModel]="formModel" [wizardTitle]="formModel.title"></create-object-dialog>`,
    styles:[`

        .modal-title{margin-top: -5px;}
        .closeBtnH4{margin-top:-5px;margin-right: -8px;}
        .appWindow {
            height: 35px;
        }
        .clientRow{background-color: #D0DFFE;}

        .led{width:22px;}

        .tableHeader{ background-image: url("../../../assets/images/blueBack.jpg");}
        th{color:#ffffff;text-align: center;}


        .modalBodyContainer {
          background-color:  #ECE8E5;
        }

        .modal-footer{background-color: #ECE8E5;}
        .modal-body {
            width: 100%;
            padding: 0;
            overflow-y: auto;
            height: 600px;
        }
        .modal-body thead {
            position: sticky;
            top:0;
        }
        ::-webkit-scrollbar {
            width: 14px;
            height: 5px;
            background-color: #F5F3F0;
        }
        ::-webkit-scrollbar-thumb {
            height: 6px;
            border: 4px solid rgba(0, 0, 0, 0);
            background-clip: padding-box;
            -webkit-border-radius: 7px;
            background-color:#BACEFF;
            -webkit-box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05);
        }
        ::-webkit-scrollbar-button {
            width: 14px;
            height: 14px;
            display: none;
        }
        ::-webkit-scrollbar-corner {
            background-color: transparent;
        }

        .modal-dialog {
            max-width: 1500px;
            margin: 50px auto auto;
            background-color: #0064FE;
            border-top-right-radius: 10px;
            border-top-left-radius: 10px;
        }

        .modal-header {
            height:56px;
            //background-color: #0064FE;
            background-image: url("../../../assets/images/headerBack.jpg");
            color: antiquewhite;
            border-top-right-radius: 10px;
            border-top-left-radius: 10px;
        }

        .modal-content {
            border-top-right-radius: 10px;
            border-top-left-radius: 10px;
            background-color: #0064FE;
            padding-bottom: 3px;
          padding-left: 3px;
          padding-right: 3px;
        }

        .closeX {
            color: white;
            size: 25px;
        }

        .btn-outline-danger {
            background-color: #d6462e;
            border-style: solid;
            border-color: white;
            border-width: 2px;
            padding: 0;
        }

       /* .btn-outline-danger:hover {
            width: 32px;
            background-image: url("../../../assets/images/closeBtnHovered.png");
        }*/

        .closeIcon:hover{ width: 32px;background-image: url("../../../assets/images/closeBtnHovered.png");}

        .closeIcon{ width: 32px;background-image: url("../../../assets/images/closeBtn.png");}

        .btn-success {
              background-color: #08780C;

              border-style: solid;
              border-color: white;
              border-width: 2px;
          }

        .modOK{ background-image: url("../../../assets/images/290x24x24.png");background-repeat: no-repeat;}

        .btn-success:hover {
            background-color: #0CAF10;
        }

        .btn-warning {
            background-color: #F1C829;
            border-style: solid;
            border-color: white;
            border-width: 2px;
        }

        .btn-warning:hover {
            background-color: #F7DD77;
        }
    `]
})

export class ClientManagerComponent implements OnInit {


    @Output() error: EventEmitter<any> = new EventEmitter();

    private clients:Client[];
    private hide = true;

    private editUserId=0;

    private modifiedUserVal='';

    private intentModel:(Project|Client) = new Project();

    private formModel:FormModel;

    @ViewChild(CreateObjectDialogComponent) private createProjectComponent:CreateObjectDialogComponent;
    @ViewChild (GenericModalComponent) private genericModal:GenericModalComponent;

    constructor(private _projectService: ProjectService) {
    }

    ngOnInit(): void {
        this.formModel =  ClientFormUtil.generateClientForm();
    }


    fetchClients() {
        this._projectService.getRegisteredClients()
            .subscribe(data => {
                    console.log(data);
                    this.clients = Json2TypescriptUtil.getJsonConvertInstance().deserializeArray(data,Client);
                },
                error => {console.log('Error registering a device');this.error.emit('An error occurred while fetching clients:'+350+'\n Try again later.');});
    }


    toggleDialog() {
        this.hide = !this.hide;
        console.log(this.hide);
        if(this.hide===false) {
            this.fetchClients();
        }
    }

    turnOnLED(accessStatus: boolean):string {
        if(accessStatus) {
            return '../../../assets/images/greenLED.png';
        } else {
            return '../../../assets/images/redLED.png';
        }
    }

    onRemove(id: number) {
        this._projectService.removeRegisteredClient(id).subscribe((val=> {
            if(val === true) {
                this.genericModal.defineModal('Client was removed Successfully!','Client Manager',100);
            } else {
                this.genericModal.defineModal('Some error occurred while removing client!','Client Manager',350);
            }
            this.genericModal.toggleModal();
        }),
            error => {console.log('Error while removing client.');this.genericModal.defineModal('Some error occurred while removing client! \n'+error.error +' \n'+ error.status,'Client Manager',350);this.genericModal.toggleModal();});
    }

    createAccess(id: number) {

    }

    onUpdate(id: number,oldVal:string) {
        this.editUserId = id;
        this.modifiedUserVal = oldVal;
    }

    saveMod(id: number, modifiedUserVal: string) {
        console.log(id+' '+modifiedUserVal);
        let tmp:Client;
        for(const client of this.clients) {
            if(client.id === this.editUserId) {
                client.name = modifiedUserVal;
                tmp = client;
                break;
            }
        }
        this.editUserId = 0;
        this._projectService.updatedRegisteredClient(tmp).subscribe((val=> {
            if(val === true) {
                this.genericModal.defineModal('Client Updated Successfully!','Client Manager',200);
            } else {
                this.genericModal.defineModal('Some error occurred while updating client!','Client Manager',350);
            }
            this.genericModal.toggleModal();
        }),
            error => {console.log('Error while updating client.');this.genericModal.defineModal('Some error occurred while updating client!'+error,'Client Manager',350);this.genericModal.toggleModal();});
    }

    onOk() {

        this.genericModal.toggleModal();
        this.fetchClients();
    }

    private showAddClient() {
        this.intentModel = new Client();
        this.formModel = ClientFormUtil.generateClientForm();
        this.createProjectComponent.toggleDialog();
    }

    onNewEvent(event:string) {
        switch (event) {
            case 'project': this.createProjectComponent.toggleDialog();window.location.reload();break;
            case 'client': this.createProjectComponent.toggleDialog();break;
        }
    }
}
